export const appSettings = {
  disableLogs: true,
};
